import EmptyState from "../../components/shared/EmptyState";
import ErrorState from "../../components/shared/ErrorState";
import LoadingState from "../../components/shared/LoadingState";
import ScheduleDaysTable from "../../components/schedule/ScheduleDaysTable";
import { usePublishedSchedules } from "../../hooks/usePublishedSchedules";
import { useNavigationHelper } from "../../hooks/useNavigationHelper";
import { useCompetitionsContext } from "../../contexts/CompetitionsContext";
import { Container } from "@mui/material";
import { useMemo } from "react";
import { useParams } from "react-router-dom";

/**
 * Lista opublikowanych dni harmonogramu (gdy jest więcej niż jeden dzień).
 * Layout jak lista kategorii / rund — {@link ModernTable} + nagłówek sekcji.
 */
export default function ScheduleList() {
  const { competitionId } = useParams<{ competitionId: string }>();
  const { schedules, loading, error, refreshSchedules } = usePublishedSchedules(competitionId);
  const { goToCompetitions, goToScheduleDay } = useNavigationHelper();
  const { competitions } = useCompetitionsContext();

  const competitionName = useMemo(() => {
    if (!competitionId) {
      return undefined;
    }
    const competition = competitions.find((item) => item.id === competitionId);
    return competition?.fullName || competition?.name;
  }, [competitionId, competitions]);

  if (!competitionId) {
    return (
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <EmptyState message="Nieprawidłowy adres turnieju." />
      </Container>
    );
  }

  if (loading) {
    return (
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <LoadingState message="Ładowanie harmonogramu..." />
      </Container>
    );
  }

  if (error) {
    return (
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <ErrorState message={error} onRetry={refreshSchedules} />
      </Container>
    );
  }

  if (schedules.length === 0) {
    return (
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <EmptyState message="Brak opublikowanego harmonogramu." />
      </Container>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ py: 2 }}>
      <ScheduleDaysTable
        schedules={schedules}
        competitionName={competitionName}
        onBack={() => goToCompetitions()}
        onRowClick={(schedule) => goToScheduleDay(competitionId, schedule.id)}
        emptyMessage="Brak opublikowanego harmonogramu."
      />
    </Container>
  );
}
